<template>
  <VpFormLayout>
    <template v-slot:content-header>
      <PageHeader className="d-flex align-items-center" :title="title" />
    </template>
    <template v-slot:content-body>
      <section>
        <b-form id="form" class="form-horizontal" @submit.prevent="onSubmit">
          <div class="add-reason-section">
            <div class="add-reason-container">
              <div>
                <!-- Attendance Mode  -->
                <div class="attendance-mode">
                  <span
                    class="selections-label"
                    v-if="form.attendance_mode && dropdown_closed"
                  >
                    {{ $t("attendanceModes.attendanceMode") }}
                  </span>
                  <multiselect
                    id="attendance-mode"
                    v-model="form.attendance_mode"
                    label="name"
                    :options="[]"
                    :placeholder="$t('attendanceModes.attendanceMode')"
                    track-by="id"
                    style="z-index: auto"
                    :show-labels="false"
                    :hideSelected="false"
                    :searchable="true"
                    @input="attendanceModeSelected"
                    @open="dropdown_closed = false"
                    @close="dropdown_closed = true"
                    :disabled="!!$route.query.attendance_mode_id"
                  >
                  </multiselect>
                </div>

                <!-- Reason Name  -->
                <div class="reason-name">
                  <div class="form-group m-d-gruop width-416">
                    <b-form-input
                      required
                      id="reason-name"
                      v-model.trim="form.reason_name"
                      type="text"
                      maxlength="20"
                    />
                    <label for="reason-name">{{
                      $t("attendanceModes.reason.reasonName")
                    }}</label>
                  </div>
                </div>

                <!-- Presented Reason  -->
                <div class="presented-reason">
                  <span
                    class="selections-label"
                    v-if="presentedReason.length > 0"
                  >
                    {{ $t("attendanceModes.reason.presentedReasonOptional") }}
                  </span>

                  <multiselect
                    id="presented-reason"
                    class="presented-reasons"
                    v-model="presentedReason"
                    :options="[]"
                    :placeholder="
                      presentedReason.length == 0
                        ? $t('attendanceModes.reason.presentedReasonOptional')
                        : ''
                    "
                    :show-labels="false"
                    :taggable="true"
                    @tag="addTag"
                    multiple
                  >
                  </multiselect>
                </div>
                <div>
                  <h6 class="datepicker-hintone" style="margin-bottom: 17px">
                    <b>{{ $t("common.notes.note") }}: </b>
                    {{
                      $t(
                        "attendanceModes.reason.reasonMustBeUniqueWith20CharactersMax"
                      )
                    }}
                  </h6>
                </div>

                <!-- Reason Type  -->
                <div class="reason-type">
                  <span
                    class="selections-label"
                    v-if="form.reason_type && reasondropdown_closed"
                    >{{ $t("attendanceModes.reason.reasonType") }}</span
                  >

                  <multiselect
                    id="reason-type"
                    class="reason-type"
                    v-model="form.reason_type"
                    label="name"
                    :options="getTypeOptions"
                    :placeholder="$t('attendanceModes.reason.reasonType')"
                    track-by="id"
                    style="z-index: auto"
                    :show-labels="true"
                    :hideSelected="false"
                    :searchable="true"
                    @close="reasondropdown_closed = true"
                    @open="reasondropdown_closed = false"
                    @input="typeSelected"
                  >
                  </multiselect>
                </div>
                <div
                  v-if="
                    !form.reason_type &&
                    getTypeOptions.find((item) => item.$isDisabled)
                  "
                >
                  <h6 class="datepicker-hintone">
                    <b>{{ $t("common.notes.note") }}: </b
                    >{{ $t("common.no") }} "{{
                      getTypeOptions.find((item) => item.$isDisabled).name
                    }}"
                    {{
                      $t(
                        "attendanceModes.reason.reasonsCouldBeAddedBecauseAllTheRelatedAttendanceCodesLinkedToOtherReasons"
                      )
                    }}
                  </h6>
                </div>

                <!-- Duration  -->
                <div
                  class="duration"
                  v-if="form.reason_type && form.reason_type.id == 'sign_out'"
                >
                  <div
                    class="form-group m-d-gruop width-416 input-icons"
                    style="margin-bottom: -38px !important"
                  >
                    <b-form-input
                      required
                      class="duration-width"
                      id="duration"
                      v-model="durationString"
                      type="text"
                    />
                    <i v-if="!durationString" class="icon fa fa-clock"></i>
                    <i
                      v-else
                      class="icon cancel-icon fa fa-times"
                      style="cursor: pointer"
                      @click="
                        durationString = null;
                        duration = 0;
                      "
                    ></i>
                    <label for="duration">{{
                      $t("attendanceModes.reason.durationOptional")
                    }}</label>
                  </div>
                  <vue-timepicker
                    ref="timepicker"
                    class="duration-timepicker"
                    :time="duration"
                    format="HH:mm"
                    @input="updateDuration"
                    :hour-range="[[0, calculateTimeRange().hours]]"
                    :minute-range="availableMinutes"
                    hide-disabled-hours
                  ></vue-timepicker>
                </div>
                <div
                  v-if="form.reason_type && form.reason_type.id == 'sign_out'"
                >
                  <h6 class="datepicker-hintone">
                    <b>{{ $t("common.notes.note") }}: </b
                    >{{ $t("attendanceModes.reason.durationCantBeMoreThan") }}
                    {{ calculateTimeRange().hours }}{{ $t("common.h")
                    }}{{
                      calculateTimeRange().minutes
                        ? ` ${calculateTimeRange().minutes}m.`
                        : "."
                    }}
                  </h6>
                </div>

                <!-- From - To  -->
                <div
                  class="from-to-wrapper"
                  v-if="form.attendance_mode && !wondeIntegration"
                >
                  <div class="from-to-con d-flex">
                    <div style="margin-inline-end: 15px">
                      <div
                        class="error-msg-con"
                        :class="{ 'is-invalid': hasFromErr }"
                      >
                        <span class="from-to-label" v-if="form.fromTime">{{
                          $t("attendanceModes.from")
                        }}</span>
                        <date-picker
                          id="from_time"
                          class="pre-reg-datepicker"
                          :class="{ 'selected-date-value': form.fromTime }"
                          :use12h="true"
                          :show-second="false"
                          format="hh:mm A"
                          v-model="form.fromTime"
                          value-type="date"
                          type="time"
                          placeholder="From"
                          :default-value="calculatedStartDate"
                          @input="
                            hasFromErr = false;
                            hasToErr = false;
                            durationErr = false;
                            errorMessage = '';
                            form.toTime = '';
                            throwErr = false;
                          "
                          @close="checkDateValidation()"
                        >
                          <i slot="icon-calendar">
                            <svg
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                                :fill="form.fromTime ? '#103F5E' : '#787878'"
                              />
                            </svg>
                          </i>
                        </date-picker>
                      </div>
                      <p class="time-error-msg" v-if="hasFromErr">
                        {{
                          $t(
                            "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
                          )
                        }}
                        ({{ calculatedFrom }} - {{ calculatedTo }}).
                      </p>
                    </div>

                    <div
                      :class="{ disabledValue: !form.fromTime && !form.toTime }"
                    >
                      <div
                        class="error-msg-con"
                        :class="{ 'is-invalid': hasToErr }"
                      >
                        <span class="from-to-label" v-if="form.toTime">{{
                          $t("attendanceModes.to")
                        }}</span>
                        <date-picker
                          id="to_time"
                          class="pre-reg-datepicker"
                          :class="{
                            'selected-date-value': form.toTime,
                          }"
                          :use12h="true"
                          :show-second="false"
                          :disabled="!form.fromTime && !form.toTime"
                          format="hh:mm A"
                          v-model="form.toTime"
                          value-type="date"
                          type="time"
                          placeholder="To"
                          :disabled-time="toStartTime"
                          :default-value="form.fromTime"
                          @input="
                            hasToErr = false;
                            durationErr = false;
                            errorMessage = '';
                            throwErr = false;
                          "
                          @close="checkDateValidation()"
                        >
                          <i slot="icon-calendar">
                            <svg
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                                :fill="form.toTime ? '#103F5E' : '#787878'"
                              />
                            </svg>
                          </i>
                        </date-picker>
                      </div>

                      <p
                        v-if="hasToErr && errorMessage"
                        class="time-error-msg"
                        style="width: 160px"
                      >
                        {{ errorMessage }}
                      </p>
                      <p
                        class="time-error-msg"
                        v-else-if="hasToErr"
                        style="width: 160px"
                      >
                        {{
                          durationErr
                            ? `${$t(
                                "attendanceModes.reason.durationReasonEndTimeCantExceed"
                              )} ${originalCalculatedTo}.`
                            : `${$t(
                                "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
                              )} (${calculatedFrom} - ${calculatedTo}).`
                        }}
                      </p>
                    </div>
                  </div>

                  <div v-if="!hasToErr && !hasFromErr">
                    <h6 class="datepicker-hintone">
                      <b>{{ $t("common.notes.note") }}:</b>
                      {{
                        $t(
                          "attendanceModes.reason.timeRangeMustBeWithInTheModesTimeRange"
                        )
                      }}
                      ({{ calculatedFrom }} - {{ calculatedTo }}).
                    </h6>
                  </div>
                </div>

                <div class="wonde-integration" v-else-if="form.attendance_mode">
                  <div class="separator-line"></div>
                  <h6 class="datepicker-hint">
                    <b>{{ $t("common.notes.note") }}:</b>
                    {{
                      $t(
                        "attendanceModes.reason.theAttendanceCodesBelowAreSyncedToVisiPointVia"
                      )
                    }}
                    "{{ intgName }}".
                    {{
                      $t(
                        "attendanceModes.reason.timeRangesMustBeWithinTheModesTimeRange"
                      )
                    }}
                    ({{ calculatedFrom }} - {{ calculatedTo }})
                    {{ $t("attendanceModes.reason.andCantOverlapEachOther") }}
                  </h6>

                  <!-- Repeater  -->
                  <div
                    class="d-flex flex-row mb-3"
                    style="justify-content: flex-start"
                    v-for="(item, i) in attendanceCodes"
                    :key="`attendance${i}`"
                  >
                    <div class="attendance-code">
                      <span
                        class="selections-label"
                        v-if="item.code && codedropdown_closed"
                        >{{ $t("attendanceModes.reason.attendanceCode") }}</span
                      >
                      <!-- <multiselect
                        class="attendance-code"
                        id="attendance-code"
                        v-model="item.code"
                        label="label"
                        :options="allAttendanceCodes"
                        placeholder="Attendance Code"
                        track-by="id"
                        style="z-index: auto"
                        :show-labels="false"
                        :hideSelected="false"
                        :searchable="true"
                        :disabled="!form.reason_type"
                        @close="codedropdown_closed = true"
                        @open="codedropdown_closed = false"
                      >
                      </multiselect> -->
                      <treeselect
                        v-model="item.code"
                        id="attendance-code"
                        class="attendance-code"
                        :disabled="!form.reason_type"
                        :multiple="false"
                        :options="computedOptions"
                        :clearOnSelect="true"
                        :flat="false"
                        :default-expand-level="0"
                        :placeholder="
                          $t('attendanceModes.reason.attendanceCode')
                        "
                      />
                    </div>
                    <div class="from-to-error">
                      <div class="from-to-con2 d-flex">
                        <div
                          class="repeater-from"
                          style="margin-inline-end: 15px"
                        >
                          <div>
                            <div
                              class="error-msg-con"
                              :class="{
                                'is-invalid': item.hasErr || item.hasFromErr,
                              }"
                            >
                              <span class="from-to-label" v-if="item.from">{{
                                $t("attendanceModes.from")
                              }}</span>
                              <date-picker
                                id="repeater-from"
                                class="pre-reg-datepicker"
                                :class="{
                                  'selected-date-value': item.from,
                                }"
                                :show-second="false"
                                :use12h="true"
                                type="time"
                                format="hh:mm A"
                                value-type="date"
                                v-model="item.from"
                                :placeholder="$t('attendanceModes.from')"
                                :disabled-time="disableFromTime"
                                :default-value="calculatedStartDate"
                                @input="
                                  item.hasErr = false;
                                  item.hasFromErr = false;
                                  item.hasToErr = false;
                                  item.durationErr = false;
                                  errorMessage = '';
                                  item.to = '';
                                  throwErr = false;
                                  item.causedErrTo || item.causedErrTo == 0
                                    ? (attendanceCodes[
                                        item.causedErrTo
                                      ].hasErr = false)
                                    : '';
                                  item.causedErrTo || item.causedErrTo == 0
                                    ? (errorMessage = '')
                                    : '';
                                "
                                @close="checkDateValidation()"
                              >
                                <i slot="icon-calendar">
                                  <svg
                                    width="19"
                                    height="19"
                                    viewBox="0 0 19 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                                      :fill="item.from ? '#103F5E' : '#787878'"
                                    />
                                  </svg>
                                </i>
                              </date-picker>
                            </div>
                            <p v-if="item.hasFromErr" class="time-error">
                              {{
                                $t(
                                  "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
                                )
                              }}
                              ({{ calculatedFrom }} - {{ calculatedTo }}).
                            </p>
                          </div>
                        </div>

                        <div class="repeater-to">
                          <div>
                            <div
                              class="error-msg-con"
                              :class="{
                                'is-invalid': item.hasErr || item.hasToErr,
                              }"
                            >
                              <div
                                :class="{
                                  disabledValue: !item.from && !item.to,
                                }"
                              >
                                <span class="from-to-label" v-if="item.to">{{
                                  $t("attendanceModes.to")
                                }}</span>
                                <date-picker
                                  id="repeater-to"
                                  class="pre-reg-datepicker"
                                  :class="{
                                    'selected-date-value': item.to,
                                  }"
                                  :disabled="!item.from && !item.to"
                                  :show-second="false"
                                  :use12h="true"
                                  type="time"
                                  format="hh:mm A"
                                  value-type="date"
                                  v-model="item.to"
                                  :placeholder="$t('attendanceModes.to')"
                                  :default-value="calculatedStartDate"
                                  @input="
                                    item.hasErr = false;
                                    item.hasToErr = false;
                                    item.durationErr = false;
                                    errorMessage = '';
                                    throwErr = false;
                                    item.causedErrTo || item.causedErrTo == 0
                                      ? (attendanceCodes[
                                          item.causedErrTo
                                        ].hasErr = false)
                                      : '';
                                    item.causedErrTo || item.causedErrTo == 0
                                      ? (errorMessage = '')
                                      : '';
                                  "
                                  @close="checkDateValidation()"
                                >
                                  <i slot="icon-calendar">
                                    <svg
                                      width="19"
                                      height="19"
                                      viewBox="0 0 19 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M9.5 0.75C4.6875 0.75 0.75 4.6875 0.75 9.5C0.75 14.3125 4.6875 18.25 9.5 18.25C14.3125 18.25 18.25 14.3125 18.25 9.5C18.25 4.6875 14.3125 0.75 9.5 0.75ZM12.5625 11.25C12.3 11.6875 11.775 11.775 11.3375 11.6L9.0625 10.2875C8.8 10.1125 8.625 9.85 8.625 9.5V5.125C8.625 4.6 8.975 4.25 9.5 4.25C10.025 4.25 10.375 4.6 10.375 5.125V8.975L12.2125 10.025C12.65 10.2875 12.7375 10.8125 12.5625 11.25Z"
                                        :fill="item.to ? '#103F5E' : '#787878'"
                                      />
                                    </svg>
                                  </i>
                                </date-picker>
                              </div>
                            </div>
                            <p
                              v-if="item.hasToErr && errorMessage"
                              class="time-error"
                            >
                              {{ errorMessage }}
                            </p>
                            <p v-else-if="item.hasToErr" class="time-error">
                              {{
                                item.durationErr
                                  ? `${$t(
                                      "attendanceModes.reason.durationReasonEndTimeCantExceed"
                                    )} ${originalCalculatedTo}.`
                                  : `${$t(
                                      "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
                                    )} (${calculatedFrom} - ${calculatedTo}).`
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <p
                        v-if="item.hasErr"
                        class="time-error-range"
                        style="width: 277px"
                      >
                        {{
                          $t(
                            "attendanceModes.reason.timeRangeCantOverlapWithOtherRanges"
                          )
                        }}
                      </p>
                    </div>
                    <svg
                      style="margin-inline-start: 25px; margin-top: 20px"
                      v-if="i > 0"
                      @click="attendanceCodes.splice(i, 1)"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                        fill="#F46A6A"
                      />
                    </svg>
                  </div>

                  <button
                    type="button"
                    class="add-new-reason"
                    @click="
                      attendanceCodes.push({
                        code: null,
                        from: '',
                        to: '',
                        hasErr: false,
                        hasFromErr: false,
                        hasToErr: false,
                      })
                    "
                    :disabled="
                      !isAttendanceCodeValid ||
                      attendanceCodes.find(
                        (item) =>
                          item.hasErr || item.hasFromErr || item.hasToErr
                      ) ||
                      allCodesAreUsed
                    "
                  >
                    {{ $t("common.addNew") }}
                  </button>
                  <span class="all-atendance" v-if="allCodesAreUsed"
                    >({{
                      $t(
                        "attendanceModes.reason.allAttendanceCodesAreLinkedToReasons"
                      )
                    }})</span
                  >
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </section>
    </template>
    <template v-slot:content-footer>
      <VpButton
        :text="
          isEditReason
            ? $t('attendanceModes.grid.editReason')
            : $t('attendanceModes.grid.addReason')
        "
        :disabled="
          isLoading ||
          $v.$invalid ||
          (wondeIntegration &&
            (!isAttendanceCodeValid ||
              attendanceCodes.find(
                (item) => item.hasErr || item.hasFromErr || item.hasToErr
              ))) ||
          (!wondeIntegration && (!!hasFromErr || !!hasToErr)) ||
          (isEditReason && formNotChanged)
        "
        @click="onSubmit"
        :isLoading="isLoading"
        :height="'37px'"
        :width="'151px'"
      />
    </template>
  </VpFormLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import VueTimepicker from "vue2-timepicker";
import { required, requiredIf } from "vuelidate/lib/validators";
import moment from "moment";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";

export default {
  title: "Add Reason",
  components: {
    PageHeader,
    Multiselect,
    VueTimepicker,
    Treeselect,
  },
  name: "addReason",
  data() {
    return {
      title: this.$t("attendanceModes.grid.addReason"),
      durationString: "",
      duration: 0,
      open: false,
      codedropdown_closed: true,
      reasondropdown_closed: true,
      dropdown_closed: true,
      presentedReasonList: [],
      presentedReason: [],
      hours: "",
      minutes: "",
      wondeIntegration: false,
      attendanceModeStartTime: "",
      attendanceModeEndTime: "",
      attendanceModeStartDate: "",
      attendanceModeEndDate: "",
      originalAttendanceModeStartTime: "",
      originalAttendanceModeEndTime: "",
      originalAttendanceModeStartDate: "",
      originalAttendanceModeEndDate: "",
      form: {
        attendance_mode: null,
        reason_name: null,
        reason_type: null,
        fromTime: null,
        toTime: null,
        duration: null,
      },
      attendanceCodes: [
        {
          code: null,
          from: "",
          to: "",
          hasErr: false,
          hasFromErr: false,
          hasToErr: false,
        },
      ],
      allAttendanceCodes: [],
      isSubmitted: false,
      errorMessage: "",
      hasFromErr: null,
      hasToErr: null,
      durationErr: null,
      intgName: "",
      isEditReason: false,
      isLoading: false,
      allCodesAreUsed: false,
      throwErr: false,
      getAllAttendanceCodes: [],
    };
  },
  validations: {
    form: {
      attendance_mode: {
        required,
      },
      reason_name: {
        required,
      },
      reason_type: {
        required,
      },
      fromTime: {
        required: requiredIf(function () {
          return !this.wondeIntegration;
        }),
      },
      toTime: {
        required: requiredIf(function () {
          return !this.wondeIntegration;
        }),
      },
    },
  },
  computed: {
    ...mapGetters("attendanceMode", [
      "getAttendanceModes",
      "getAttendanceCodes",
    ]),
    ...mapGetters("authfack", ["currentEntity"]),
    availableMinutes() {
      if (+this.hours == +this.calculateTimeRange().hours)
        return [[0, +this.calculateTimeRange().minutes]];
      return [[0, 59]];
    },
    computedOptions() {
      const selectedCodes = this.attendanceCodes.map((item) => item.code);
      const options = this.allAttendanceCodes.map((option) => {
        const disabled =
          selectedCodes.includes(option.id) ||
          (option.is_used &&
            (!this.$route.query.id ||
              this.$route.query.id != option.reason_id));
        return { ...option, disabled, isDisabled: disabled };
      });
      return options;
    },
    getTypeOptions() {
      const options = [
        { id: "sign_in", name: this.$t("common.signIn") },
        { id: "sign_out", name: this.$t("common.signOut") },
      ];
      return options;
    },
    isAttendanceCodeValid() {
      const emptyArr = this.attendanceCodes.find(
        (item) => !item.code || !item.from || !item.to
      );
      return emptyArr ? false : true;
    },
    formNotChanged() {
      if (!this.isEditReason) return false;
      const todayDate = moment(new Date()).format("YYYY-MM-DD");

      if (!this.wondeIntegration) {
        const type =
          this.$route.query.reason_type == "Sign in"
            ? { id: "sign_in", name: "Sign in" }
            : { id: "sign_out", name: "Sign out" };
        console.log("formNotChanged");
        if (
          (this.form.attendance_mode &&
            this.form.attendance_mode.id !=
              this.$route.query.attendance_mode_id) ||
          this.form.reason_name != this.$route.query.reason_name ||
          (this.form.reason_type && this.form.reason_type.id != type.id) ||
          moment(new Date(this.form.fromTime)).format("HH:mm") !=
            moment(
              new Date(`${todayDate} ${this.$route.query.from_time}`)
            ).format("HH:mm") ||
          moment(new Date(this.form.toTime)).format("HH:mm") !=
            moment(
              new Date(`${todayDate} ${this.$route.query.to_time}`)
            ).format("HH:mm") ||
          JSON.stringify(this.presentedReason) !=
            JSON.stringify(
              this.$route.query.presented ? this.$route.query.presented : []
            ) ||
          this.durationString != this.$route.query.duration
        )
          return false;
      } else {
        const type =
          this.$route.query.reason_type == "Sign in"
            ? { id: "sign_in", name: "Sign in" }
            : { id: "sign_out", name: "Sign out" };
        const items = JSON.parse(this.$route.query.attendance_codes);
        let itemChanged = false;
        const todayDate = moment(new Date()).format("YYYY-MM-DD");
        items.map((item, i) => {
          const from = this.attendanceCodes[i]
            ? moment(new Date(this.attendanceCodes[i].from)).format("HH:mm")
            : "";
          const to = this.attendanceCodes[i]
            ? moment(new Date(this.attendanceCodes[i].to)).format("HH:mm")
            : "";
          if (
            !this.attendanceCodes[i] ||
            moment(new Date(`${todayDate} ${item.from_time}`)).format(
              "HH:mm"
            ) != moment(new Date(`${todayDate} ${from}`)).format("HH:mm") ||
            moment(new Date(`${todayDate} ${item.to_time}`)).format("HH:mm") !=
              moment(new Date(`${todayDate} ${to}`)).format("HH:mm") ||
            item.id != this.attendanceCodes[i].code
          ) {
            itemChanged = true;
          }
        });
        console.log("formNotChanged");
        if (
          (this.form.attendance_mode &&
            this.form.attendance_mode.id !=
              this.$route.query.attendance_mode_id) ||
          this.form.reason_name != this.$route.query.reason_name ||
          (this.form.reason_type && this.form.reason_type.id != type.id) ||
          JSON.stringify(this.presentedReason) !=
            JSON.stringify(
              this.$route.query.presented ? this.$route.query.presented : []
            ) ||
          this.durationString != this.$route.query.duration ||
          this.attendanceCodes.length != items.length ||
          itemChanged
        )
          return false;
      }
      return true;
    },
    calculatedFrom() {
      const todayDate = moment(new Date()).format("YYYY-MM-DD");
      return moment(
        new Date(`${todayDate} ${this.attendanceModeStartTime}`)
      ).format("hh:mm A");
    },
    calculatedTo() {
      const todayDate = moment(new Date()).format("YYYY-MM-DD");
      return moment(
        new Date(`${todayDate} ${this.attendanceModeEndTime}`)
      ).format("hh:mm A");
    },
    originalCalculatedTo() {
      const todayDate = moment(new Date()).format("YYYY-MM-DD");
      return moment(
        new Date(`${todayDate} ${this.originalAttendanceModeEndTime}`)
      ).format("hh:mm A");
    },
    calculatedStartDate() {
      const todayDate = moment(new Date()).format("YYYY-MM-DD");
      return new Date(`${todayDate} ${this.attendanceModeStartTime}`);
    },
  },
  methods: {
    ...mapActions("attendanceMode", [
      "fetchAttendanceModeById",
      "fetchAttendanceCodes",
      "addReason",
      "editReason",
    ]),
    // ...mapActions("integration", ["findIntegration"]),
    // allCodesAreUsed() {
    //   const codeAvailable = this.allAttendanceCodes.find(item => !item.isDisabled);
    //   console.log("allCodesAreUsed", this.allAttendanceCodes, codeAvailable);
    //   return codeAvailable ? false : true;
    // },
    generateTimeOptions() {
      const options = [];
      for (let hours = 0; hours <= 8; hours++) {
        const option = {
          value: `${hours.toString().padStart(2, "0")}:00`,
          text: `${hours} hours`,
        };
        options.push(option);
      }
      return options;
    },

    updateDuration(time) {
      if (
        +time.HH == +this.calculateTimeRange().hours &&
        +time.mm > +this.calculateTimeRange().minutes
      )
        time.mm = "00";
      const hours = time.HH;
      const minutes = time.mm;
      this.hours = time.HH;
      this.minutes = time.mm;
      // const time = moment(new Date(selectedTime)).format("HH:mm");

      this.duration = hours * 60 + Number(minutes); // duration in minutes
      // console.log(this.duration);
      this.formatDurationString();
      this.checkDateValidation();
    },
    formatDurationString() {
      const hours = Math.floor(this.duration / 60);
      const minutes = this.duration % 60;
      this.durationString = `${hours}h ${minutes}m`;
    },

    showTimePicker() {
      this.open = !this.open;
      this.$nextTick(() => {
        console.log("vvv", this.$refs.timepicker.$el);
        this.$refs.timepicker.$el.focus();
      });
    },

    attendanceModeSelected() {
      console.log("attendanceModeSelected", this.form.attendance_mode);
      this.errorMessage = "";
      this.hasToErr = "";
      this.hasFromErr = "";
      if (!this.form.attendance_mode) {
        this.wondeIntegration = false;
        this.attendanceModeStartTime = "";
        this.attendanceModeEndTime = "";
        return;
      }

      this.wondeIntegration = !!this.form.attendance_mode.integration_id;
      if (!this.$route.query.id) {
        this.form.fromTime = "";
        this.form.toTime = "";
      }
      if (this.form.attendance_mode.integration_id) {
        this.intgName = this.form.attendance_mode.integration_name;
        this.fetchAttendanceCodes({
          id: this.form.attendance_mode.integration_id,
          add_reason: true,
          attendance_mode_id: this.$route.query.attendance_mode_id,
        }).then((data) => {
          console.log("data", data);
          this.getAllAttendanceCodes = data.data;
        });
      }

      const todayDate = moment(new Date()).format("YYYY-MM-DD");

      // const attendanceModeStartTime = moment.utc(`${todayDate} ${this.form.attendance_mode.calculated_from_time}`)
      // .tz(moment.tz.guess()).format(
      //   "HH:mm"
      // );
      // const attendanceModeEndTime = moment.utc(`${todayDate} ${this.form.attendance_mode.calculated_to_time}`)
      // .tz(moment.tz.guess()).format(
      //   "HH:mm"
      // );

      const attendanceModeStartTime = moment(
        `${todayDate} ${this.form.attendance_mode.calculated_from_time}`
      ).format("HH:mm");

      const attendanceModeEndTime = moment(
        `${todayDate} ${this.form.attendance_mode.calculated_to_time}`
      ).format("HH:mm");

      this.attendanceModeStartTime = attendanceModeStartTime;

      this.attendanceModeEndTime = attendanceModeEndTime;

      this.originalAttendanceModeStartTime = moment(
        `${todayDate} ${this.form.attendance_mode.from_time}`
      ).format("HH:mm");

      this.originalAttendanceModeEndTime = moment(
        `${todayDate} ${this.form.attendance_mode.to_time}`
      ).format("HH:mm");

      this.checkDateValidation();
    },

    typeSelected(type) {
      console.log("typeSelected", type);
      if (type.id == "sign_in") {
        this.durationErr = false;
        this.hasToErr = false;
        this.attendanceCodes.map((item) => {
          item.hasToErr = false;
          item.durationErr = false;
        });
      }
      this.attendanceCodes = [];
      this.createNewAttendanceCodeWithEmptyVal();
      if (!type) {
        this.allAttendanceCodes = [];
        return;
      }

      if (this.getAllAttendanceCodes) {
        console.log("this.getAllAttendanceCodes", this.getAllAttendanceCodes);
        if (type.id == "sign_in")
          this.allAttendanceCodes = this.getAllAttendanceCodes;
        if (type.id == "sign_out")
          this.allAttendanceCodes = this.getAllAttendanceCodes;

        // console.log("this.allAttendanceCodes", this.allAttendanceCodes);
        if (this.allAttendanceCodes) {
          this.allAttendanceCodes.map((item) => {
            item.isDisabled =
              item.is_used &&
              (!this.$route.query.id || this.$route.query.id != item.reason_id)
                ? true
                : false;
          });
        }
      }
    },

    addTag(newTag) {
      const trimmedNewTag = newTag.trim().toLowerCase();
      const tagExists = this.presentedReason.some(
        (item) => item.trim().toLowerCase() === trimmedNewTag
      );
      if (newTag && newTag.length <= 20 && !tagExists) {
        this.presentedReasonList.push(newTag);
        this.presentedReason.push(newTag);
      }
    },

    createNewAttendanceCodeWithEmptyVal() {
      this.attendanceCodes.push({
        code: null,
        from: "",
        to: "",
        hasErr: false,
        hasFromErr: false,
        hasToErr: false,
      });
    },

    fromStartTime(date) {
      const selectedTime = moment(new Date(date)).format("HH:mm");
      // console.log('selectedTime', selectedTime, this.attendanceModeStartTime, this.attendanceModeEndTime);
      if (this.attendanceModeStartTime > this.attendanceModeEndTime)
        return false;
      return (
        selectedTime < this.attendanceModeStartTime ||
        selectedTime > this.attendanceModeEndTime
      );
    },

    toStartTime(date) {
      const selectedTime = moment(new Date(date)).format("HH:mm");
      // const fromTime = moment(new Date(this.form.fromTime)).format("HH:mm");
      // console.log("selectedTime", selectedTime);
      // console.log("fromTime", fromTime);
      if (this.attendanceModeStartTime > this.attendanceModeEndTime)
        return false;
      return (
        // selectedTime < fromTime ||
        selectedTime < this.attendanceModeStartTime &&
        selectedTime > this.attendanceModeEndTime
      );
    },

    disableFromTime(date) {
      const selectedTime = moment(new Date(date)).format("HH:mm");
      if (this.attendanceModeStartTime >= this.attendanceModeEndTime)
        return false; // Night Shift
      return (
        selectedTime < this.attendanceModeStartTime &&
        selectedTime > this.attendanceModeEndTime
      );
    },

    disableToTime(date) {
      const selectedTime = moment(new Date(date)).format("HH:mm");
      // const fromTime = moment(new Date(this.form.fromTime)).format("HH:mm");
      // console.log("selectedTime", selectedTime);
      // console.log("fromTime", fromTime);
      if (this.attendanceModeStartTime > this.attendanceModeEndTime)
        return false;
      return (
        // selectedTime < fromTime ||
        selectedTime < this.attendanceModeStartTime ||
        selectedTime > this.attendanceModeEndTime
      );
    },

    calculateTimeRange() {
      // Parse the start and end times
      const start = this.parseTime(this.originalAttendanceModeStartTime);
      const end = this.parseTime(this.originalAttendanceModeEndTime);

      // Calculate the range in minutes
      let rangeMinutes = (end - start + 1440) % 1440; // 1440 minutes in a day

      // Convert the range to hours and minutes
      const hours = Math.floor(rangeMinutes / 60);
      const minutes = rangeMinutes % 60;

      return { hours, minutes };
    },

    // Helper function to parse time in HH:MM format
    parseTime(time) {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    },

    // ----- CheckValidation() FN SUMMARY DOCS: ------------
    // DAY SHIFT:
    // ------------ INITIALIZATIONS: -----------------------
    // fromDate & toDate = today's date
    // -----------------------------------------------------
    // ---------------------- ERRORS: ----------------------
    // if (fromDate >= toDate) => err on TO field
    // if (toTime < this.attendanceModeStartTime || toTime > this.attendanceModeEndTime) err on TO field
    // if (fromTime < this.attendanceModeStartTime || fromTime >= this.attendanceModeEndTime) => err on FROM field
    // ------------------------------------------------------

    // NIGHT SHIFT:
    // ----------------- INITIALIZATIONS: -------------------
    // fromDate, toDate = today's date.
    // if (toTime <= this.attendanceModeStartTime || toTime < fromTime) => toDate = next day's date
    // if (fromTime < this.attendanceModeStartTime && fromTime <= this.attendanceModeEndTime) || fromTime == this.attendanceModeEndTime) => fromDate, toDate = next day's date;
    // // commented in wonde overlap check => if (toTime < this.attendanceModeStartTime && toTime <= this.attendanceModeEndTime) => toDate = next day's date
    // ------------------------------------------------------
    // -------------------- ERRORS: -------------------------
    // if (fromTime == toTime || fromDate >= toDate) => err on TO field (from time is after or equal to to time)
    // if (toDate < this.attendanceModeStartDate || toDate > this.attendanceModeEndDate) => err on TO field
    // if (fromDate < this.attendanceModeStartDate || fromDate >= this.attendanceModeEndDate) err on FROM field
    // ------------------------------------------------------
    checkDateValidation() {
      let items = this.attendanceCodes.slice(); // make a copy of the items array
      let overlappingItem = null;
      let currentOvelappingItem = null;
      let hasError = false;
      this.errorMessage = "";
      this.hasFromErr = this.hasToErr = false;
      this.durationErr = false;
      this.attendanceCodes.map((item) => {
        item.hasErr = false;
        item.hasFromErr = false;
        item.hasToErr = false;
        item.durationErr = false;
      });

      const todayDate = moment(new Date()).format("YYYY-MM-DD");
      const result = new Date();
      result.setDate(result.getDate() + 1);
      const tmwDate = moment(new Date(result)).format("YYYY-MM-DD");

      this.attendanceModeStartDate = moment(
        new Date(`${todayDate} ${this.attendanceModeStartTime}`)
      ).format("YYYY-MM-DD HH:mm");
      this.attendanceModeEndDate = moment(
        new Date(`${todayDate} ${this.attendanceModeEndTime}`)
      ).format("YYYY-MM-DD HH:mm");

      this.originalAttendanceModeStartDate = moment(
        new Date(`${todayDate} ${this.originalAttendanceModeStartTime}`)
      ).format("YYYY-MM-DD HH:mm");
      this.originalAttendanceModeEndDate = moment(
        new Date(`${todayDate} ${this.originalAttendanceModeEndTime}`)
      ).format("YYYY-MM-DD HH:mm");

      if (!this.wondeIntegration) {
        if (this.form.fromTime && this.form.toTime) {
          let toDate;
          let fromDate;

          const fromTime = moment(new Date(this.form.fromTime)).format("HH:mm");
          const toTime = moment(new Date(this.form.toTime)).format("HH:mm");
          console.log(toTime);

          fromDate = moment(new Date(`${todayDate} ${fromTime}`)).format(
            "YYYY-MM-DD HH:mm"
          );
          toDate = moment(new Date(`${todayDate} ${toTime}`)).format(
            "YYYY-MM-DD HH:mm"
          );

          if (this.attendanceModeEndTime <= this.attendanceModeStartTime) {
            // Night Shift
            this.attendanceModeEndDate = moment(
              new Date(`${tmwDate} ${this.attendanceModeEndTime}`)
            ).format("YYYY-MM-DD HH:mm");

            this.originalAttendanceModeEndDate = moment(
              new Date(`${tmwDate} ${this.originalAttendanceModeEndTime}`)
            ).format("YYYY-MM-DD HH:mm");

            // if (fromTime < this.attendanceModeStartTime) { // new day
            // fromDate = moment(new Date(`${tmwDate} ${fromTime}`)).format(
            //   "YYYY-MM-DD HH:mm"
            // );
            // }

            if (toTime <= this.attendanceModeStartTime || toTime < fromTime) {
              toDate = moment(new Date(`${tmwDate} ${toTime}`)).format(
                "YYYY-MM-DD HH:mm"
              );
            }

            if (
              fromTime < this.attendanceModeStartTime &&
              fromTime <= this.attendanceModeEndTime // next day
            ) {
              fromDate = moment(new Date(`${tmwDate} ${fromTime}`)).format(
                "YYYY-MM-DD HH:mm"
              );
              toDate = moment(new Date(`${tmwDate} ${toTime}`)).format(
                "YYYY-MM-DD HH:mm"
              );
            }

            if (fromDate >= toDate) {
              // from time is after or equal to to time, set the error flag and save the invalid item
              this.errorMessage = `${this.$t(
                "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
              )} (${this.calculatedFrom}
                      - ${this.calculatedTo}).`;
              this.hasToErr = true;
              this.isLoading = false;
              console.log("errrrr", this.errorMessage);
              // return;
            }
            if (
              fromDate < this.attendanceModeStartDate ||
              fromDate >= this.attendanceModeEndDate
            ) {
              console.log("from range err");
              this.hasFromErr = true;
              this.isLoading = false;
              // return;
            }
            if (
              toDate < this.attendanceModeStartDate ||
              toDate > this.attendanceModeEndDate
            ) {
              console.log("to range err");
              this.hasToErr = true;
              this.isLoading = false;
              // return;
            }
            if (this.hasToErr || this.hasFromErr) {
              this.throwErr = true;
              return;
            }

            if (
              this.form.reason_type &&
              this.form.reason_type.id == "sign_out" &&
              moment(new Date(toDate))
                .add({ hours: this.hours, minutes: this.minutes })
                .format("YYYY-MM-DD HH:mm") > this.originalAttendanceModeEndDate
            ) {
              this.hasToErr = true;
              this.durationErr = true;
              this.isLoading = false;
              this.throwErr = true;
              return;
            }
          } else {
            //Day Shift
            if (fromDate >= toDate) {
              // from time is after or equal to to time, set the error flag and save the invalid item
              this.errorMessage = `${this.$t(
                "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
              )} (${this.calculatedFrom}
                      - ${this.calculatedTo}).`;
              this.hasToErr = true;
              this.isLoading = false;
              console.log("errrrr", this.errorMessage);
              // return;
            }
            if (
              fromTime < this.attendanceModeStartTime ||
              fromTime >= this.attendanceModeEndTime
            ) {
              console.log("from range err");
              this.hasFromErr = true;
              this.isLoading = false;
              // return;
            }
            if (
              toDate < this.attendanceModeStartDate ||
              toDate > this.attendanceModeEndDate
            ) {
              console.log(toDate);
              console.log("to range err");
              this.hasToErr = true;
              this.isLoading = false;
              // return;
            }
            if (this.hasToErr || this.hasFromErr) {
              this.throwErr = true;
              return;
            }

            if (
              this.form.reason_type &&
              this.form.reason_type.id == "sign_out" &&
              moment(new Date(this.form.toTime))
                .add({ hours: this.hours, minutes: this.minutes })
                .format("HH:mm") > this.originalAttendanceModeEndTime
            ) {
              this.hasToErr = true;
              this.durationErr = true;
              this.isLoading = false;
              this.throwErr = true;
              return;
            }
          }
        }
      } else {
        // wonde intg
        for (let i = 0; i < this.attendanceCodes.length; i++) {
          let current = this.attendanceCodes[i];
          if (current.from && current.to) {
            console.log("cuurentTo", new Date(current.to));
            console.log("cuurentFrom", new Date(current.from));

            if (this.attendanceModeEndTime > this.attendanceModeStartTime) {
              // Day Shift
              if (new Date(current.from) >= new Date(current.to)) {
                // from time is after or equal to to time, set the error flag and save the invalid item
                overlappingItem = current;
                this.errorMessage = `${this.$t(
                  "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
                )} (${this.calculatedFrom}
                      - ${this.calculatedTo}).`;
                current.hasToErr = true;
                this.isLoading = false;
                console.log("errrrr", this.errorMessage);
                // return;
              }
              if (
                moment(new Date(current.from)).format("HH:mm") <
                  this.attendanceModeStartTime ||
                moment(new Date(current.from)).format("HH:mm") >=
                  this.attendanceModeEndTime
              ) {
                // console.log("range err");
                current.hasFromErr = true;
                this.isLoading = false;
                // return;
              }
              if (
                moment(new Date(current.to)).format("HH:mm") <
                  this.attendanceModeStartTime ||
                moment(new Date(current.to)).format("HH:mm") >
                  this.attendanceModeEndTime
              ) {
                // console.log("range err");
                console.log(current.to);
                current.hasToErr = true;
                this.isLoading = false;
                // return;
              }
              if (current.hasToErr || current.hasFromErr) {
                this.throwErr = true;
                continue;
              }

              if (
                this.form.reason_type &&
                this.form.reason_type.id == "sign_out" &&
                moment(new Date(current.to))
                  .add({ hours: this.hours, minutes: this.minutes })
                  .format("HH:mm") > this.originalAttendanceModeEndTime
              ) {
                current.hasToErr = true;
                current.durationErr = true;
                this.isLoading = false;
                this.throwErr = true;
                continue;
              }
            } else {
              // Night Shift
              this.attendanceModeEndDate = moment(
                new Date(`${tmwDate} ${this.attendanceModeEndTime}`)
              ).format("YYYY-MM-DD HH:mm");

              this.originalAttendanceModeEndDate = moment(
                new Date(`${tmwDate} ${this.originalAttendanceModeEndTime}`)
              ).format("YYYY-MM-DD HH:mm");

              let toDate = moment(
                new Date(
                  `${todayDate} ${moment(new Date(current.to)).format("HH:mm")}`
                )
              ).format("YYYY-MM-DD HH:mm");

              if (
                moment(new Date(current.to)).format("HH:mm") <=
                  this.attendanceModeStartTime ||
                moment(new Date(current.to)).format("HH:mm") <
                  moment(new Date(current.from)).format("HH:mm")
              ) {
                toDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(current.to)).format("HH:mm")}`
                  )
                ).format("YYYY-MM-DD HH:mm");
              }

              let fromDate = moment(
                new Date(
                  `${todayDate} ${moment(new Date(current.from)).format(
                    "HH:mm"
                  )}`
                )
              ).format("YYYY-MM-DD HH:mm");
              if (
                (moment(new Date(current.from)).format("HH:mm") <
                  this.attendanceModeStartTime &&
                  moment(new Date(current.from)).format("HH:mm") <=
                    this.attendanceModeEndTime) ||
                moment(new Date(current.from)).format("HH:mm") ==
                  this.attendanceModeEndTime // next day
              ) {
                fromDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(current.from)).format(
                      "HH:mm"
                    )}`
                  )
                ).format("YYYY-MM-DD HH:mm");
                toDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(current.to)).format("HH:mm")}`
                  )
                ).format("YYYY-MM-DD HH:mm");
              }
              console.log(
                "fromDate",
                fromDate,
                "this.attendanceModeStartDate",
                this.attendanceModeStartDate,
                "this.attendanceModeEndDate",
                this.attendanceModeEndDate
              );
              if (
                moment(new Date(current.from)).format("HH:mm") ==
                  moment(new Date(current.to)).format("HH:mm") ||
                fromDate >= toDate
              ) {
                // from time is after or equal to to time, set the error flag and save the invalid item
                this.errorMessage = `${this.$t(
                  "attendanceModes.reason.valueMustBeWithInTheModesTimeRange"
                )} (${this.calculatedFrom}
                      - ${this.calculatedTo}).`;
                current.hasToErr = true;
                this.isLoading = false;
                console.log("errrrr", this.errorMessage);
                // return;
              }

              if (
                fromDate < this.attendanceModeStartDate ||
                fromDate >= this.attendanceModeEndDate
              ) {
                // console.log("from range err");
                current.hasFromErr = true;
                this.isLoading = false;
                // return;
              }

              console.log("toDate", toDate, this.attendanceModeEndDate);

              if (
                toDate < this.attendanceModeStartDate ||
                toDate > this.attendanceModeEndDate
              ) {
                console.log(toDate);
                console.log("to range err");
                current.hasToErr = true;
                this.isLoading = false;
                // return;
              }
              if (current.hasToErr || current.hasFromErr) {
                this.throwErr = true;
                continue;
              }

              if (
                this.form.reason_type &&
                this.form.reason_type.id == "sign_out" &&
                moment(new Date(toDate))
                  .add({ hours: this.hours, minutes: this.minutes })
                  .format("YYYY-MM-DD HH:mm") >
                  this.originalAttendanceModeEndDate
              ) {
                current.hasToErr = true;
                current.durationErr = true;
                this.isLoading = false;
                this.throwErr = true;
                continue;
              }
            }
          }
        }

        if (this.throwErr) return;

        // sort the items by start time
        if (this.attendanceModeEndTime <= this.attendanceModeStartTime) {
          // Night Shift
          items.map((item) => {
            item.fromSortDate = moment(
              new Date(
                `${todayDate} ${moment(new Date(item.from)).format("HH:mm")}`
              )
            ).format("YYYY-MM-DD HH:mm");
            item.toSortDate = moment(
              new Date(
                `${todayDate} ${moment(new Date(item.to)).format("HH:mm")}`
              )
            ).format("YYYY-MM-DD HH:mm");
            if (
              (moment(new Date(item.from)).format("HH:mm") <
                this.attendanceModeStartTime &&
                moment(new Date(item.from)).format("HH:mm") <=
                  this.attendanceModeEndTime) ||
              moment(new Date(item.from)).format("HH:mm") ==
                this.attendanceModeEndTime // next day
            ) {
              item.fromSortDate = moment(
                new Date(
                  `${tmwDate} ${moment(new Date(item.from)).format("HH:mm")}`
                )
              ).format("YYYY-MM-DD HH:mm");
              item.toSortDate = moment(
                new Date(
                  `${tmwDate} ${moment(new Date(item.to)).format("HH:mm")}`
                )
              ).format("YYYY-MM-DD HH:mm");
            }

            // if (
            //   moment(new Date(item.to)).format("HH:mm") < this.attendanceModeStartTime &&
            //   moment(new Date(item.to)).format("HH:mm") <= this.attendanceModeEndTime // next day
            // ) {
            //   item.toSortDate = moment(
            //     new Date(`${tmwDate} ${moment(new Date(item.to)).format("HH:mm")}`)
            //   ).format("YYYY-MM-DD HH:mm");
            // }
            if (
              moment(new Date(item.to)).format("HH:mm") <=
                this.attendanceModeStartTime ||
              moment(new Date(item.to)).format("HH:mm") <
                moment(new Date(item.from)).format("HH:mm") // next day
            ) {
              item.toSortDate = moment(
                new Date(
                  `${tmwDate} ${moment(new Date(item.to)).format("HH:mm")}`
                )
              ).format("YYYY-MM-DD HH:mm");
            }
          });
        } else {
          items.map((item) => {
            item.fromSortDate = moment(
              new Date(
                `${todayDate} ${moment(new Date(item.from)).format("HH:mm")}`
              )
            ).format("YYYY-MM-DD HH:mm");
            item.toSortDate = moment(
              new Date(
                `${todayDate} ${moment(new Date(item.to)).format("HH:mm")}`
              )
            ).format("YYYY-MM-DD HH:mm");
          });
        }
        items.sort((a, b) => {
          return new Date(a.fromSortDate) - new Date(b.fromSortDate);
        });

        // loop through the sorted items and check for overlaps
        for (let i = 0; i < items.length - 1; i++) {
          let current = items[i];
          let next = items[i + 1];
          if (current.from && current.to && next.from && next.to) {
            let currentFromDate = moment(new Date(current.from)).format(
              "YYYY-MM-DD HH:mm"
            );
            let currentToDate = moment(new Date(current.to)).format(
              "YYYY-MM-DD HH:mm"
            );
            let nextFromDate = moment(new Date(next.from)).format(
              "YYYY-MM-DD HH:mm"
            );
            if (this.attendanceModeEndTime <= this.attendanceModeStartTime) {
              // Night Shift
              if (
                (moment(currentFromDate).format("HH:mm") <
                  this.attendanceModeStartTime &&
                  moment(currentFromDate).format("HH:mm") <=
                    this.attendanceModeEndTime) ||
                moment(currentFromDate).format("HH:mm") ==
                  this.attendanceModeEndTime // next day
              ) {
                currentFromDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(current.from)).format(
                      "HH:mm"
                    )}`
                  )
                ).format("YYYY-MM-DD HH:mm");
                currentToDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(current.to)).format("HH:mm")}`
                  )
                ).format("YYYY-MM-DD HH:mm");
              }

              // if (
              //   moment(currentToDate).format("HH:mm") < this.attendanceModeStartTime &&
              //   moment(currentToDate).format("HH:mm") <= this.attendanceModeEndTime // next day
              // ) {
              //   currentToDate = moment(
              //     new Date(`${tmwDate} ${moment(new Date(current.to)).format("HH:mm")}`)
              //   ).format("YYYY-MM-DD HH:mm");
              // }

              if (
                moment(currentToDate).format("HH:mm") <=
                  this.attendanceModeStartTime ||
                moment(currentToDate).format("HH:mm") <
                  moment(currentFromDate).format("HH:mm") // next day
              ) {
                currentToDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(current.to)).format("HH:mm")}`
                  )
                ).format("YYYY-MM-DD HH:mm");
              }

              if (
                moment(nextFromDate).format("HH:mm") <
                  this.attendanceModeStartTime &&
                moment(nextFromDate).format("HH:mm") <=
                  this.attendanceModeEndTime // next day
              ) {
                nextFromDate = moment(
                  new Date(
                    `${tmwDate} ${moment(new Date(next.from)).format("HH:mm")}`
                  )
                ).format("YYYY-MM-DD HH:mm");
              }
            }

            console.log("cuurentTo", currentToDate);
            console.log("cuurentFrom", currentFromDate);
            console.log("nextFromDate", nextFromDate);

            if (currentToDate >= nextFromDate) {
              // there is an overlap, set the error flag and save the overlapping item
              hasError = true;
              overlappingItem = next;
              currentOvelappingItem = current;
              break;
            }
          }
        }

        if (hasError) {
          // errorMessage = `There is an overlap in the time range for item "${overlappingItem.code.label}".`;
          const nextItemExist = this.attendanceCodes.find(
            (item) => item.code == overlappingItem.code
          );
          const nextIndex = this.attendanceCodes.indexOf(nextItemExist);

          const currentItemExist = this.attendanceCodes.find(
            (item) => item.code == currentOvelappingItem.code
          );
          const currentIndex = this.attendanceCodes.indexOf(currentItemExist);

          if (nextIndex > currentIndex) {
            nextItemExist.hasErr = true;
            currentItemExist.causedErrTo = nextIndex;
          } else {
            currentItemExist.hasErr = true;
            nextItemExist.causedErrTo = currentIndex;
          }
          this.isLoading = false;
          console.log("overlappingItem", overlappingItem);
          this.throwErr = true;
          return;
        }
      }
    },

    async onSubmit() {
      this.isLoading = true;
      console.log(this.form, this.presentedReason, this.attendanceCodes);

      await this.checkDateValidation();

      if (!this.throwErr) {
        console.log("success");
        const obj = {
          name: this.form.reason_name,
          presented: this.presentedReason,
          entity_id: this.currentEntity.id,
          attendance_mode_id: this.form.attendance_mode.id,
          duration: this.durationString,
          type: this.form.reason_type.id,
          // from: moment(new Date(this.form.fromTime)).format("HH:mm"),
          // to: moment(new Date(this.form.toTime)).format("HH:mm"),
        };

        if (this.wondeIntegration) {
          const items = this.attendanceCodes.map((item) => {
            return {
              id: item.code,
              // from_time: moment.utc(new Date(item.from)).format('HH:mm'),
              // to_time: moment.utc(new Date(item.to)).format("HH:mm"),
              from_time: moment(new Date(item.from)).format("HH:mm"),
              to_time: moment(new Date(item.to)).format("HH:mm"),
            };
          });

          obj.attendance_codes = items;
          obj.integration_id = this.form.attendance_mode.integration_id;
          obj.integration_name = this.intgName;
        } else {
          // obj.from_time = moment.utc(new Date(this.form.fromTime)).format("HH:mm");
          // obj.to_time = moment.utc(new Date(this.form.toTime)).format("HH:mm");

          obj.from_time = moment(new Date(this.form.fromTime)).format("HH:mm");
          obj.to_time = moment(new Date(this.form.toTime)).format("HH:mm");
        }
        console.log("obj", obj);
        if (this.isEditReason) {
          this.editReason({ obj, reason_id: this.$route.query.id })
            .then(() => {
              this.isLoading = false;
            })
            .catch((err) => {
              console.log("err", err);
              this.isLoading = false;
              if (err.data.data.index) {
                if (err.data.data.from)
                  this.attendanceCodes[
                    err.data.data.index[0]
                  ].hasFromErr = true;
                else if (err.data.data.to)
                  this.attendanceCodes[err.data.data.index[0]].hasToErr = true;
              } else if (err.data.data.from) {
                this.hasFromErr = true;
              } else if (err.data.data.to) {
                this.hasToErr = true;
              }
            });
        } else {
          this.addReason(obj)
            .then(() => {
              this.isLoading = false;
            })
            .catch((err) => {
              console.log("err", err);
              this.isLoading = false;
              if (err.data.data.index) {
                if (err.data.data.from_time)
                  this.attendanceCodes[
                    err.data.data.index[0]
                  ].hasFromErr = true;
                else if (err.data.data.to_time)
                  this.attendanceCodes[err.data.data.index[0]].hasToErr = true;
              } else if (err.data.data.from_time) {
                this.hasFromErr = true;
              } else if (err.data.data.to_time) {
                this.hasToErr = true;
              }
            });
        }
      }
    },
  },
  watch: {
    getAllAttendanceCodes(attendanceCodes) {
      console.log("getAllAttendanceCodes", attendanceCodes);
      if (!this.isEditReason) {
        this.attendanceCodes = [
          {
            code: null,
            from: "",
            to: "",
            hasErr: false,
            hasFromErr: false,
            hasToErr: false,
          },
        ];
      } else if (
        this.attendance_mode &&
        this.attendance_mode.id != this.$route.query.attendance_mode_id
      ) {
        this.attendanceCodes = [
          {
            code: null,
            from: "",
            to: "",
            hasErr: false,
            hasFromErr: false,
            hasToErr: false,
          },
        ];
      }
      this.allAttendanceCodes = [];
      if (this.form.reason_type && this.form.reason_type.id == "sign_in")
        this.allAttendanceCodes = attendanceCodes;
      if (this.form.reason_type && this.form.reason_type.id == "sign_out")
        this.allAttendanceCodes = attendanceCodes;
      if (this.allAttendanceCodes) {
        this.allAttendanceCodes.map((item) => {
          item.isDisabled =
            item.is_used &&
            (!this.$route.query.id || this.$route.query.id != item.reason_id)
              ? true
              : false;
        });
      }

      if (
        !this.getAllAttendanceCodes.find(
          (item) => !item.is_used || this.$route.query.id == item.reason_id
        )
      ) {
        this.getTypeOptions.find(
          (item) => item.id == "sign_in"
        ).$isDisabled = true;
      }
      if (
        !this.getAllAttendanceCodes.find(
          (item) => !item.is_used || this.$route.query.id == item.reason_id
        )
      ) {
        this.getTypeOptions.find(
          (item) => item.id == "sign_out"
        ).$isDisabled = true;
      }
    },
    attendanceCodes: {
      handler(arr) {
        // console.log("arr", arr);
        let codeSelected = [];
        if (arr) {
          codeSelected = arr.map((item) => {
            if (item.code && item.code) return item.code;
          });
        }
        // console.log("codeSelected", codeSelected);
        if (this.allAttendanceCodes) {
          this.allAttendanceCodes.map((item) => {
            // console.log('includes', codeSelected.includes(item.id));
            item.isDisabled =
              codeSelected.includes(item.id) ||
              (item.is_used &&
                (!this.$route.query.id ||
                  this.$route.query.id != item.reason_id))
                ? true
                : false;
          });
        }

        if (this.allAttendanceCodes && this.allAttendanceCodes.length > 0) {
          const codeAvailable = this.allAttendanceCodes.find(
            (item) => !item.isDisabled
          );
          console.log(
            "allCodesAreUsed",
            this.allAttendanceCodes,
            codeAvailable
          );
          this.allCodesAreUsed = codeAvailable ? false : true;
        }
      },
      deep: true,
      immediate: true,
    },
    allAttendanceCodes: {
      handler(arr) {
        console.log("allAttendanceCodes", arr);
        const codeSelected = this.attendanceCodes.map((item) => {
          if (item.code) return item.code;
        });
        if (arr) {
          arr.map((item) => {
            item.isDisabled =
              codeSelected.includes(item.id) ||
              (item.is_used &&
                (!this.$route.query.id ||
                  this.$route.query.id != item.reason_id))
                ? true
                : false;
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.fetchAttendanceModeById(this.$route.query.attendance_mode_id).then(
      (data) => {
        // console.log("dataaaa", data);
        this.form.attendance_mode = data;
        this.attendanceModeSelected();
      }
    );
    if (this.$route.query.id) {
      // edit reason
      this.isEditReason = true;
      this.title = "Edit Reason";
      const todayDate = moment(new Date()).format("YYYY-MM-DD");

      this.form.reason_name = this.$route.query.reason_name;
      this.form.reason_type =
        this.$route.query.reason_type == "Sign in"
          ? { id: "sign_in", name: "Sign in" }
          : { id: "sign_out", name: "Sign out" };
      this.form.fromTime = new Date(
        `${todayDate} ${this.$route.query.from_time}`
      );
      this.form.toTime = new Date(`${todayDate} ${this.$route.query.to_time}`);
      this.presentedReason = this.$route.query.presented
        ? JSON.parse(JSON.stringify(this.$route.query.presented))
        : [];
      this.durationString = this.$route.query.duration;
      if (this.durationString) {
        const match = this.durationString.match(/(\d+)h\s*(\d+)m/);

        if (match) {
          const hours = parseInt(match[1], 10);
          const minutes = parseInt(match[2], 10);
          this.hours = hours;
          this.minutes = minutes;
        }
      }
      if (this.$route.query.attendance_codes) {
        const items = JSON.parse(this.$route.query.attendance_codes);
        this.attendanceCodes = items.map((item) => {
          return {
            code: item.id,
            from: new Date(`${todayDate} ${item.from_time}`),
            to: new Date(`${todayDate} ${item.to_time}`),
            hasErr: false,
            hasFromErr: false,
            hasToErr: false,
          };
        });
        console.log("cccc", this.attendanceCodes);
      }
      console.log("query", this.$route.query);
    }
  },
};
</script>

<style lang="scss">
//    .multiselect__option--highlight {
//   background: red;
// }
div#repeater-to {
  width: 200px !important;
}
div#repeater-from {
  width: 200px !important;
}
div#from_time {
  width: 200px !important;
}
div#to_time {
  width: 200px !important;
}
.disabledValue {
  opacity: 0.8 !important;
  cursor: not-allowed;
}
.pre-reg-datepicker {
  input.mx-input::placeholder {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    margin-inline-start: 20px;
    padding-inline-start: 10px;
    color: #787878;
  }
  .mx-input:disabled {
    &::placeholder {
      color: #787878;
    }
  }
  input.mx-input {
    background-color: #f2f2f2 !important;
    border: none !important;
    border-radius: 4px !important;
    height: 55px !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87) !important;
  }
}
input#presented-reason::placeholder {
  font-weight: 400 !important;
  font-size: 16px;
  line-height: 17px;
  letter-spacing: 0.25px !important;
  color: rgba(96, 96, 96, 0.87) !important;
  opacity: 0.8;
}

.presented-reason {
  .multiselect {
    z-index: 10;
    .multiselect__input {
      background: #f2f2f2 !important;
    }
    .multiselect__placeholder {
      font-weight: 400 !important;
      font-size: 16px;
      line-height: 17px;
      padding-inline-start: 10px;
      letter-spacing: 0.25px;
      color: rgba(96, 96, 96, 0.87) !important;
      opacity: 0.8;
    }
    .multiselect__tag {
      font-size: 16px !important;
      line-height: 17px !important;
      font-weight: 700 !important;
      letter-spacing: 0.25px !important;
      padding-top: 10px !important;
      padding-inline-end: 48px !important;
      padding-bottom: 12px !important;
      padding-inline-start: 20px !important;
      border-radius: 6px !important;
      &:first-child {
        margin-top: 25px;
      }
      .multiselect__tag-icon:after {
        font-size: 22px;
      }
      i.multiselect__tag-icon {
        width: 32px;
        font-size: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i.multiselect__tag-icon:hover {
        background: #f46a6a;
      }
    }
  }
}

.duration {
  .vue__time-picker .dropdown {
    width: 416px !important;
  }
  .vue__time-picker .dropdown .select-list {
    width: 416px !important;
  }
}

button.add-new-reason {
  background: #2680eb;

  border-radius: 4px;
  border: none;
  width: 107px;
  height: 37px;
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #ffffff;
  &:disabled {
    opacity: 0.4;
  }
}
span.all-atendance {
  margin-inline-start: 16px;

  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
}
.time-error-msg,
.time-error-range {
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  width: 160px;
  text-align: start;
  letter-spacing: 0.25px;
  margin-inline-start: 22px;
  margin-top: 8px;
  color: #f46a6a;
}
.time-error {
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  width: 160px;
  text-align: start;
  letter-spacing: 0.25px;
  margin-inline-start: 22px;
  margin-top: 8px;
  color: #f46a6a;
}
.from-to-label {
  position: absolute;
  color: #103f5e;
  margin-top: 10px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 20px;
  z-index: 2;

  font-size: 15px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
  margin-top: 5px;
}
.from-to-wrapper {
  // margin-top: 17px;

  .from-to-label {
    position: absolute;
    color: #103f5e;
    margin-top: 10px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 20px;
    z-index: 2;

    font-size: 15px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
    margin-top: 5px;
  }
}
.selected-date-value {
  input.mx-input {
    padding-inline-start: 20px !important;
    padding-top: 25px !important;
  }
}
input.mx-input {
  height: 55px !important;

  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 17px !important;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 0.8;
  padding-inline-start: 20px !important;
  // padding-top: 25px!important;
}

input#attendance-mode::placeholder,
input#attendance-code::placeholder {
  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  /* identical to box height, or 106% */

  letter-spacing: 0.25px;

  /* #787878 */

  color: #787878;
}
input#reason-type,
input#attendance-mode,
input#attendance-code {
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 17px;
  /* identical to box height, or 106% */

  letter-spacing: 0.25px;
  background: #f2f2f2 !important;

  color: #787878 !important;
  .multiselect__single {
    background: #f2f2f2 !important;

    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    margin-inline-start: 7px;

    letter-spacing: 0.25px !important;
    padding-top: 15px;

    color: rgba(0, 0, 0, 0.87) !important;

    opacity: 0.8 !important;
  }
}
.presented-reason,
.reason-type,
.attendance-code,
.attendance-mode,
.repeater-to,
.repeater-from,
.error-msg-con,
.presented-reasons {
  position: relative;
  // .multiselect__select {
  //   display: none;
  // }
}
.selections-label {
  position: absolute;
  color: #103f5e;
  margin-top: 10px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 20px;
  z-index: 100;

  font-size: 12px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
}
.duration-timepicker input {
  width: 380px !important;
  height: 50px !important;
  opacity: 0;
  margin-top: -80px;
}
.duration-timepicker .clear-btn {
  display: none;
}
.b-modal-lg .modal-dialog {
  max-width: 100%;
  width: auto;
  margin: 0;
}

.b-modal-lg .modal-content {
  height: 100%;
}

.multiselect__dropdown {
  position: static !important;
  transform: none !important;
}
</style>

<style lang="scss" scoped>
::v-deep {
  .from-to-con {
    margin-top: 17px;
  }
  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }

  .pre-reg-datepicker .mx-input {
    height: 55px !important;
  }
  .pre-reg-datepicker .mx-input {
    & .is-invalid {
      height: 53px !important;
    }
  }
  .vue-treeselect__menu::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  .vue-treeselect__menu::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }
  .attendance-code {
    .vue-treeselect__list-item.vue-treeselect__indent-level-0 {
      border-bottom: 1px solid #e3e1e1;
      &:last-child {
        border-bottom: none;
      }
    }
    .vue-treeselect__option--disabled {
      background: #f5f5f5 !important;
      label {
        opacity: 0.4;
      }
    }
    .vue-treeselect__label-container {
      font-weight: 400;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: #787878;
      padding-top: 12px;
      padding-inline-end: 12px;
      padding-bottom: 14px;
      padding-inline-start: 12px;
    }
    label.vue-treeselect__label {
      max-width: 100%;
      word-break: break-all;
      white-space: normal;
    }
    //.vue-treeselect__menu {
      // max-height: 185px !important;
    //}
    .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */
      padding-top: 17px;
      padding-inline-start: 17px;
      letter-spacing: 0.25px;

      /* #787878 */

      color: #787878;
      // &:disabled{
      //   color: red!important;
      // }
    }
    .vue-treeselect--disabled {
      .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
        opacity: 0.4 !important;
      }
    }
    .vue-treeselect__control {
      width: 416px;
      height: 55px;
      border: none;
      background: #f2f2f2;
      border-radius: 4px;
      margin-inline-end: 17px;
    }
    .vue-treeselect--disabled .vue-treeselect__single-value {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      padding-inline-start: 17px;

      letter-spacing: 0.25px;

      /* #787878 */

      color: #787878;

      opacity: 0.4 !important;
    }
    .vue-treeselect__single-value {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */
      padding-inline-start: 15px;
      letter-spacing: 0.25px;

      /* #787878 */
      padding-top: 26px;
      color: #787878 !important;
    }
    .vue-treeselect__menu-container {
      width: 416px;
    }

    .vue-treeselect--disabled .vue-treeselect__control-arrow-container,
    .vue-treeselect__control-arrow-container {
      cursor: default;
      padding-inline-end: 15px;
    }
    .vue-treeselect__control-arrow-container {
      color: #636161;
    }
    .vue-treeselect svg {
      fill: #787878;
    }
    .vue-treeselect__x-container {
      display: none;
    }
    // .vue-treeselect__control-arrow-container{
    //   display: none;
    // }
    //     margin-inline-end: 8px;
    //     height: 55px !important;
    //     span.multiselect__option{
    //       display: inline-block;
    //     max-width: 100%;
    //     word-break: break-all;
    //     white-space: normal;
    //     }
    //     .multiselect__option--highlight {
    //   background: red;
    // }
    //     // .multiselect__option--highlight:after{
    //     //   background: red!important;
    //     // }
    //     // span.multiselect__option:hover{
    //     //   display: inline-block;
    //     // max-width: 100%!important;
    //     // background: red!important;

    //     // }
    //     // li.multiselect__element{
    //     //   background: #103F5E!important;
    //     // }

    //     // ul.multiselect__content{

    //     // }
    //     span.multiselect__single {
    //       text-overflow: ellipsis;
    //       overflow: hidden;
    //       white-space: nowrap;
    //       width: 346px;
    //     }
  }
  .input-icons i {
    position: relative;
    float: inline-end;
  }

  .input-icons {
    width: 100%;
    margin-bottom: 10px;
  }

  .icon {
    // margin-inline-end: 35px;
    margin-top: -20px;
    color: #103f5e;
  }
  .cancel-icon {
    color: #636161 !important;
  }
  .width-416 {
    width: 416px !important;
  }
  .mx-datepicker-main.mx-datepicker-popup {
    z-index: 9999999999999;
  }

  .add-reason-section {
    .separator-line {
      height: 1px;
      width: 415px;
      margin: 33px 0px 16px 0px;
      background: #000000;
      opacity: 0.08;
    }
    .multiselect__content-wrapper {
      z-index: 105;
    }
    min-height: 500px !important;
    background-color: white;
    padding-top: 38px;
    padding-inline-end: 36px !important;
    padding-inline-start: 38px;
    border-radius: 8px;
    padding-bottom: 38px;
    .is-invalid {
      border: 1.5px solid #f46a6a !important;
      border-radius: 4px;
    }

    .submit-action {
      margin-top: 63px;
      // margin-inline-start: -17px;
      .add-visitor {
        border-radius: 18.5px;
        width: 151px;
        height: 37px;
        display: flex;
        align-items: center;
        justify-content: center;

        font-weight: 500;
        font-size: 16px;
        line-height: 17px;
        /* identical to box height, or 106% */

        text-align: center;
        letter-spacing: 0.25px;

        color: #ffffff;
      }
    }

    .add-reason-container {
      .multiselect {
        width: 416px;
        margin-bottom: 17px;
        border-radius: 4px !important;
        .multiselect__select {
          top: 7px !important;
        }
        .multiselect__select:before {
          z-index: 2;
        }
        .multiselect__tags {
          // height: 55px !important;
          background: #f2f2f2 !important;
          border-radius: 4px !important;
          border: none !important;
          display: flex;
          align-items: center;
          .multiselect__single {
            background: #f2f2f2 !important;

            font-weight: 700 !important;
            font-size: 16px !important;
            line-height: 17px !important;
            margin-inline-start: 7px;

            letter-spacing: 0.25px !important;
            padding-top: 15px;

            color: rgba(0, 0, 0, 0.87) !important;

            opacity: 0.8 !important;
          }
          .multiselect__placeholder {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            padding-inline-start: 10px;

            letter-spacing: 0.25px;

            color: rgba(96, 96, 96, 0.87) !important;

            opacity: 0.8;
          }
        }
      }

      .presented-reason .multiselect__content-wrapper {
        display: none;
      }

      input#user-type {
        background: #f2f2f2 !important;
        //   border-radius: 4px!important;

        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        padding-inline-start: 57px !important;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.87);
        // opacity: 0;
        &::placeholder {
          font-weight: 400;
          font-size: 16px;
          line-height: 17px;
          // padding-inline-start:57px!important;
          /* identical to box height, or 106% */

          letter-spacing: 0.25px;

          color: rgba(0, 0, 0, 0.87);

          opacity: 0.8;
        }
      }

      span.multiselect__single {
        font-weight: 900 !important;
        font-size: 16px;
        line-height: 17px;
        margin-inline-start: 20px;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.87);
        opacity: 0.8;
      }

      h6.datepicker-hint {
        width: 415px;

        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 32px !important;
        color: #939393;
        margin-top: 18px;
        line-height: 24px;
        opacity: 0.8;
        text-align: start;
      }
      h6.datepicker-hintone {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        // margin-bottom: 48px !important;
        color: #939393;
        margin-top: 8px !important;
        line-height: 24px;
        //opacity: 0.8;
        width: 377px;
        margin-inline-start: 22px;
      }
    }
    .presented-reason {
      .multiselect__tags {
        min-height: 55px !important;
        display: grid !important;
      }
      .multiselect__select {
        display: none;
      }
    }
    .attendance-mode,
    .reason-type,
    .attendance-code {
      .multiselect__tags {
        height: 55px !important;
      }
    }
    .attendance-mode {
      .multiselect--disabled {
        .multiselect__select {
          display: none;
        }
      }
    }
  }
}
</style>
